import { Formatters } from '../modules'
import { FIELD_USER } from './_common'

export default {
  props: {
    note: { label: '记录', required: true },
    time_created: {
      label: '建立时间',
      type: 'time',
    },
    _creator: FIELD_USER(),
  },

  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
      permissions: 'basic.modify.rooms.history_notes',
    },
  },
  layouts: {
    default: {
      layout: ['note', 'time_created', '_creator'],
    },
    detail: {
      layout: ['note', 'time_created', '_creator'],
    },
  },

  form: {
    create: {
      type: 'post',
      url() { return `rooms/${this.meta.room_id}/history_notes` },
      confirm: '确定添加该记录？',
      loadOnSuccess: 'rooms',
    },
    modify: {
      type: 'put',
      url() { return `rooms/${this.meta.room_id}/history_notes/${this.form._id}` },
      confirm: '确定保存修改？',
      loadOnSuccess: 'rooms',
    },
    layout: [
      ['note'],
    ],
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/history_notes.js